export default __webpack_public_path__ + "static/media/voice-cicrle.11cd489c.svg";